<template>
  <div>
    <component
      :title="slideoverTitle"
      :is="slideoverComponent"
      :visible="slideoverVisible"
      v-on:toggle-slideover="closeSlideover"
      @creating-discount="creatingDiscount"
      @discount-created="discountCreated"
    />

    <MainHeader>
      <div class="lg:flex lg:items-center lg:justify-between">
        <!-- Left side -->
        <div class="flex-1 min-w-0">
          <div class="flex items-center pr-4 sm:truncate">
            <h1
              class="text-2xl font-bold leading-7 text-cool-gray-900 sm:leading-9"
            >
              <span>
                Discounts
              </span>
            </h1>
          </div>
        </div>

        <!-- Right side  -->
        <div class="mt-5 flex lg:mt-0 lg:ml-4 space-x-2">
          <Button v-on:click-handler="openCreateDiscountSlideover">
            Create Discount
          </Button>
        </div>
      </div>
    </MainHeader>

    <div class="h-32 max-w-2xl mx-auto p-4">
      <DiscountCreated 
        v-if="showCreatedDiscount"
        :code="discountCode"
      />
    </div>

    <SearchDiscounts class="max-w-2xl mx-auto" />
  </div>
</template>
<script>
import Button from "@/components/elements/Button.vue";
import MainHeader from "@/components/elements/MainHeader.vue";
import DiscountCreated from "./components/DiscountCreated.vue";
import SearchDiscounts from "./components/SearchDiscounts.vue";
import CreateDiscountSlideover from "./components/slideovers/CreateDiscount.vue";

export default {
  name: "Discounts",
  components: {
    Button,
    MainHeader,
    DiscountCreated,
    SearchDiscounts,
    CreateDiscountSlideover
  },
  data() {
    return {
      slideoverComponent: null,
      slideoverTitle: null,
      slideoverVisible: false,
      showCreatedDiscount: false,
      discountCode: null
    }
  },
  methods: {
    openCreateDiscountSlideover() {
      this.slideoverComponent = "CreateDiscountSlideover";
      this.slideoverTitle = "Create Discount";

      setTimeout(() => {
        this.slideoverVisible = true;
      }, 5);
    },
    closeSlideover() {
      this.slideoverVisible = false;

      setTimeout(() => {
        this.slideoverComponent = null;
      }, 500);
    },
    creatingDiscount() {
      this.showCreatedDiscount = false;
      this.discountCode = null;
    },
    discountCreated(code) {
      this.showCreatedDiscount = true;
      this.discountCode = code;
    }
  }
};
</script>
